// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__24w9s","dragIcon":"Choice_dragIcon__1eNAb","left":"Choice_left__2QFNw","input":"Choice_input__Oz55P"};